export default function id<T>(value: T): T {
  return value;
}
